"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyleInjectionFeature = void 0;
const Feature_1 = require("../Feature");
class StyleInjectionFeature extends Feature_1.Feature {
    #config;
    constructor(config, card) {
        super(card);
        this.#config = config;
    }
    populateInputData(dataProvider) { }
    apply(dataProvider, featureExecutionResults) {
        if (this.card.module.executionCtx?.isSilentMode)
            return true;
        if (!document.getElementById("tbl-style-injection")) {
            const style = document.createElement("style");
            style.id = "tbl-style-injection";
            style.innerHTML = this.#config.tempStyle;
            document.head.appendChild(style);
        }
        const item = document.createElement("div");
        item.className = this.#config.className;
        this.card.htmlElement.parentElement.appendChild(item);
        return true;
    }
}
exports.StyleInjectionFeature = StyleInjectionFeature;
